﻿/**
 * get Central Standard Time (Austin time).
 *
 */
const getCentralStandardTime = () => {
  // Get current time
  const date = new Date();

  // The difference, in minutes, between the date as evaluated in the UTC time zone and
  // as evaluated in the local time zone. The actual local time algorithm is implementation-defined,
  // and the return value is allowed to be zero in runtimes without appropriate data.
  const browsertTimeZone = date.getTimezoneOffset();

  // convert browsertTimeZone to milliseconds
  // get UTC time in milliseconds
  const utc = date.getTime() + browsertTimeZone * 60000;

  //  Get the number of milliseconds of central standard time.
  // 3600000 is the conversion of hours to milliseconds
  // -5 is the GMT-5 time zone of austin. We just need to multply the value.
  // 3600000 * -5 = -18000000 milliseconds
  const centralStandardTimeZone = -18000000;

  // Calculate the new date with the central standard timezone.
  const now = new Date(utc + centralStandardTimeZone);

  return (
    `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}` +
    `T${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getMilliseconds()}-05:00`
  );
};

export default getCentralStandardTime;
